export function valueOrDefault (value, defaultValue) {
  return value || defaultValue
}

export function ternary (condition, valueIfTrue, valueIfFalse) {
  return {
    [true]: valueIfTrue,
    [false]: valueIfFalse
  }[Boolean(condition)]
}
